module.exports = require("@apollo/react-hooks");